import { styled } from '../../theme';
import { Typography } from '../typography';
import { MODAL_MOBILE_BREAKPOINT_THRESHOLD, name } from './const';

const Header = styled(Typography, { name, slot: 'Header' })(({ theme }) => ({
  ...theme.typography.h2,
  textAlign: 'center',
  flexGrow: 1,
  [theme.breakpoints.up(MODAL_MOBILE_BREAKPOINT_THRESHOLD)]: {
    ...theme.typography.h1,
  },
})) as unknown as typeof Typography;

export const ModalHeader = Header;
